const collapseLeftbarReducer = (state = false, action) => {
  switch (action.type) {
    case "COLLAPSE_LEFTBAR":
      return true;
    case "EXPAND_LEFTBAR":
      return false;
    default:
      return state;
  }
};

export default collapseLeftbarReducer;
